import { mdiArrowRight, mdiFileOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'

import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { searchAtom } from '@/store/app/AppAtom'
import { IConversationListItem } from '@/types/gigiChat/Conversation'

const TranslateTitle = ({ item }: { item: IConversationListItem }) => {
    const isNewChat = item.settings.title === 'New Chat'
    const isDocs = item.questionAction === 'QDocTranslate'
    const docs = item.questionDisplayData?.displayData?.fileNames
    const textColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'var(--chakra-colors-gray-500)')
    const [searchString] = useAtom(searchAtom)

    return (
        <Flex flexDir="column">
            <Flex alignItems="center" justifyContent="space-between" color={textColor} fontSize="14px">
                {isNewChat && <Text>{item.settings.title}</Text>}
                {!isNewChat && (
                    <Flex alignItems="center">
                        <Text as="span">{isDocs ? 'Documents' : 'Text'}</Text>
                        <Icon path={mdiArrowRight} size="16px" style={{ margin: '0 8px' }} />
                        <Text>
                            {item.questionDisplayData?.displayData.languageNames &&
                                item.questionDisplayData?.displayData.languageNames.join(', ')}
                        </Text>
                    </Flex>
                )}
            </Flex>
            {isDocs && (
                <Flex flexDir="row" alignItems="center" mt="12px">
                    <Flex flexDir="column">
                        {docs &&
                            docs.slice(0, searchString ? docs.length : 2).map((doc, index) => (
                                <Flex flexDir="row" alignItems="center" gap="8px" key={doc + index}>
                                    <Icon path={mdiFileOutline} size="16px" />
                                    <Text as="span">{doc}</Text>
                                </Flex>
                            ))}
                    </Flex>
                </Flex>
            )}
            {!isDocs && item.settings.title && !isNewChat && (
                <Text mt="12px">
                    {item.settings.title.slice(0, 130)}
                    {item.settings.title.length > 130 ? '...' : ''}
                </Text>
            )}
        </Flex>
    )
}

export default TranslateTitle
